import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PlanState } from './plan.reducer';

export const selectPlanState = createFeatureSelector<PlanState>('plans');

export const selectPlan = createSelector(selectPlanState, (state: PlanState) => state?.plan);
